import React, {useEffect} from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import {Spin, Typography} from 'antd';
import './index.css';
import {getResources} from '../../../actions/content';
import {HTMLContent} from '../../../components/common';

const {Title} = Typography;

function ResourcesPage(props) {
  const {
    onGetResources, content, title, isFetching
  } = props;

  useEffect(() => {
    onGetResources();
  }, []);

  return (
    isFetching
      ? (<div className="spin__wrapper"><Spin size="large"/></div>)
      : (
        <div className="content__wrapper">
          <Title level={3}>{title}</Title>
          <HTMLContent content={content}/>
        </div>
      )
  );
}

ResourcesPage.propTypes = {
  onGetResources: PropTypes.func.isRequired,
  content: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  isFetching: PropTypes.bool.isRequired
};

const mapStateToProps = ({content: {resources: {title, content}, isFetching}}) => ({
  content, title, isFetching
});

const bindActions = dispatch => ({
  onGetResources: () => dispatch(getResources())
});

export default connect(mapStateToProps, bindActions)(ResourcesPage);
